<template>
  <div id="QualityRawBase">
    <v-skeleton-loader v-if="loading" type="heading, divider">
    </v-skeleton-loader>
    <v-toolbar v-else>
      <v-toolbar-title>
        <v-chip
          color="primary"
          dark
          label
          :to="{ name: 'Quality' }"
          class="mx-2"
        >
          <v-icon small left>{{ ticket.nameIcon }}</v-icon>
          {{ ticket.name }}
        </v-chip>
      </v-toolbar-title>
      <v-icon left>mdi-calendar-clock</v-icon>Submitted:
      {{ ticket.created_on }}
      <v-spacer/>
      <ArchiveForm :instance="ticket"/>
      <v-badge left class="px-2 ml-3" overlap>
        <template v-slot:badge>{{ ticket.samples }}</template>
        <v-icon>{{ ticket.samplesIcon }}</v-icon>
      </v-badge>
      <v-icon v-if="ticket.rush" color="red darken-2" class="px-3">
        {{ ticket.rushIcon }}
      </v-icon>
      <TicketRawForm :instance="ticket" :is-edit="true"/>
      <v-btn icon @click="initialize"><v-icon>refresh</v-icon></v-btn>
    </v-toolbar>
    <v-row justify="center">
      <v-col md="10" sm="12">
        <v-skeleton-loader
          v-if="loading"
          type="card-heading, image, article"
        />
        <v-card v-else outlined>
          <v-tabs grow v-model="tabs">
            <v-tab :to="{ name: 'QualityRawDetail', params: { id: this.id } }">
              Data
            </v-tab>
            <v-tab :to="{ name: 'QualityRawPrint', params: { id: this.id } }">
              Print
            </v-tab>
            <v-tab
              :to="{
                name: 'QualityRawAttachments',
                params: { id: this.id }
              }"
            >
              Attachments
            </v-tab>
          </v-tabs>
          <v-card-text>
            <router-view :ticket="ticket"/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TicketRawForm from "../../components/Quality/QualityRawTicketForm";
import { RawTicket } from "../../models/Ticket";
import ArchiveForm from "../../components/State/ArchiveForm";
export default {
  name: "QualityRaw",
  components: {
    ArchiveForm,
    TicketRawForm
  },
  data() {
    return {
      loading: true,
      tabs: null
    };
  },
  props: {
    id: {
      required: true,
      type: [Number, String]
    }
  },
  computed: {
    ticket() {
      return RawTicket.query()
        .with("rawmaterials")
        .with("attachments")
        .find(parseInt(this.id));
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      RawTicket
        .$get(this.id)
        .then(() => this.loading = false);
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>
